import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import CategoryForm from '../../../components/SiteAdmin/CategoryForm/CategoryForm';
import Loader from '../../../components/Common/Loader/Loader';
import NotFound from '../../../components/NotFound/NotFound';
import getHomePageCategorySettings from './getHomePageCategorySettings.graphql';
import messages from '../../../locale/messages';
import { withQuery } from '../../../hoc/withGraphql';

export class EditTopFeature extends Component {
    static propTypes = {
        id: PropTypes.number.isRequired
    }
    static defaultProps = {
        data: {
            loading: true
        }
    }
    render() {
        const { getHomePageCategorySettings: { getHomePageCategorySettings, loading } } = this.props;
        const { formatMessage } = this.props.intl;
        let initialValues = {};

        if (!loading && getHomePageCategorySettings) {
            initialValues = {
                id: getHomePageCategorySettings?.id,
                logo: getHomePageCategorySettings?.logo,
                banner: getHomePageCategorySettings?.banner,
            }

            if (getHomePageCategorySettings?.dynamicHomePageCategorySettings?.length) {
                initialValues['title'] = getHomePageCategorySettings?.dynamicHomePageCategorySettings.map((item) => ({
                    language: item?.language,
                    title: item?.title,
                    description: item?.description
                }))
            }
        }

        if (!loading && !getHomePageCategorySettings) {
            return <NotFound title={formatMessage(messages.pageNotFound)} />;
        } else {
            return (
                <Loader type={"page"} show={loading}>
                    {!loading && <CategoryForm initialValues={initialValues} />}
                </Loader>
            )
        }
    }
}

export default compose(injectIntl,
    withQuery(getHomePageCategorySettings, {
        name: 'getHomePageCategorySettings',
        options: (props) => ({
            variables: {
                id: props.id
            },
            fetchPolicy: 'network-only',
            ssr: false
        })
    }))(EditTopFeature)
